import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { InfoPanelEditing } from './info-panel-editing';

export class InfoPanel extends Plugin {
  static get requires() {
    return [InfoPanelEditing];
  }
}
